.bleed {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--tuna-spacing-3);
  padding: var(--tuna-spacing-5);
  text-align: center;
}

.verdict {
  margin: 0;
  max-width: 460px;
  font-size: var(--tuna-typography-body1-fontSize);
  font-weight: 700;
  color: var(--tuna-feedback-warning-text);
}
